module.exports = __webpack_public_path__ + "static/Artboard-12-8be0ebe919f49dc178466b6e27851d4a.png";